import { isDev } from '~/utils/env'
export default function({ redirect }) {
  if (!isDev()) {
    return redirect('/')
  }
}
